import { ShoppingBasket } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface MenuBasketBarProps {
  count: number
  onOpen: () => void
}

export function MenuBasketBar({ count, onOpen }: MenuBasketBarProps) {
  if (count === 0) {
    return null
  }

  return (
    <div className="fixed inset-x-0 bottom-4 z-40 flex justify-center px-4">
      <div className="flex w-full max-w-md items-center justify-between gap-4 rounded-full bg-orange-600 py-2 pl-5 pr-2 text-white shadow-lg">
        <div className="flex items-center gap-2 text-sm font-medium">
          <ShoppingBasket className="h-5 w-5" />
          <span>
            {count} {count === 1 ? 'gerecht' : 'gerechten'} in je mandje
          </span>
        </div>
        <Button
          variant="secondary"
          size="sm"
          className="rounded-full bg-white text-orange-700 hover:bg-orange-50"
          onClick={onOpen}
        >
          Boodschappen
        </Button>
      </div>
    </div>
  )
}
